export const BEGIN_TIME_LIMIT = '6:00 AM';
export const END_TIME_LIMIT = '5:45 AM';
